var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gwells-header',{ref:"header"}),_c('main',{staticClass:"p-0 mt-4",attrs:{"role":"main"}},[_c('router-view')],1),_c('gwells-footer'),_c('back-to-top',{attrs:{"target":_vm.$refs.header}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }